import React from 'react';
import EntitlementStore from '../stores/EntitlementStore';
import EntitlementConstants from '../constants/EntitlementConstants';
import EntitlementActions from '../actions/EntitlementActions';
import * as Inovx from '@shared';

var SystemActions = Inovx.Shared.System.Actions;
var SystemStore = Inovx.Shared.System.Store;
var InovxControls = Inovx.Shared.Controls;

var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var ListHelper = Inovx.Shared.Common.ListHelper;

declare var InovxLoader: any;

interface EntitlementFormProps {
}

interface EntitlementFormState {
    securityGroup?: ISecurityGroup | any;
    isAdding?: boolean;
    isEditing?: boolean;

    applicationPermissions?: IApplicationPermission[];
    groupUsers?: IUser[];

    isActionInProgress?: boolean;
    actionInProgressMsg?: string;
    validation?: IValidationDictionaryObject;
}

function getActionInProgress(): boolean {
    return SystemStore.isActionInProgress(EntitlementConstants.ENTITLEMENT_ADD) ||
        SystemStore.isActionInProgress(EntitlementConstants.ENTITLEMENT_EDIT);
}

var _displaySelectUserState: boolean;
var _actionInProgressMsg: string;

function getFormState(): EntitlementFormState {
    return {
        securityGroup: EntitlementStore.getSecurityGroup(),
        isAdding: EntitlementStore.getIsAdding(),
        isEditing: EntitlementStore.getIsEditing(),
        isActionInProgress: getActionInProgress(),
        actionInProgressMsg: _actionInProgressMsg,

        applicationPermissions: EntitlementStore.getSecurityGroupDetail().ApplicationPermissions,
        groupUsers: EntitlementStore.getSecurityGroupDetail().GroupUsers,
        validation: EntitlementStore.getValidation(EntitlementConstants.ENTITLEMENT_ADD_FORM)
    };
}

class EntitlementForm extends React.Component<EntitlementFormProps, EntitlementFormState> {
    constructor(props: EntitlementFormProps) {
        super(props)

        this.state = getFormState();
    }

    private _onChange = (event: any) => {
        EntitlementActions.editSecurityGroup(EntitlementConstants.ENTITLEMENT_ADD_FORM, event.target.name, event.target.value);
    }

    private _loadState = () => {
        this.setState(getFormState());
    }

    private _systemChange= () => {
        this.setState({
            isActionInProgress: getActionInProgress()
        });
    }

    private _validateEntitlement = () => {
        if (!EntitlementStore.getIsValidEditObject()) {
            EntitlementActions.displayInvalidEdit();

            return false;
        }

        return EntitlementStore.getIsValidObject(EntitlementConstants.ENTITLEMENT_ADD_FORM);
    }

    private _saveEntitlement = () => {
        if (this._validateEntitlement()) {
            if (!EntitlementActions.checkFacilityPermission()) {
                var messageObject = {
                    message: InovxLoader.t("Entitlement:message.useFacilityExplorerPermissionError")
                };
                SystemActions.displayWarningMessage(messageObject);
                return;
            }
            if (this.state.isAdding) {
                EntitlementActions.createEntitlement();
            } else {
                EntitlementActions.updateEntitlement();
            }
            this.setState({ actionInProgressMsg: InovxLoader.t('Entitlement:form.saving') });
        } else {
            this.setState({});
        }
    }

    private _cancel = () => {
        EntitlementActions.finishEdit();
    }

    private _updatePermissions = (id: string, event: any) => {
        EntitlementActions.editPermissions(id, event.target.checked);
    }

    private _isEmptyOrNull = (value: string) => {
        return value && value.length > 0;
    }

    private _validateUsers = (users: IUser[]) => {
        var assignedUsers = this.state.groupUsers;
        var messageObject: any = {
            message: InovxLoader.t("Entitlement:message.duplicateUser")
        };
        var dupUsers: string[] = [];
        var duplicatUserFound = false;
        for (var i = 0; i < users.length; i++) {
            var user = users[i];
            for (var j = 0; j < assignedUsers.length; j++) {
                var assignedUser = assignedUsers[j];
                if (user.UserName === assignedUser.UserName && user.UserID === assignedUser.UserID) {
                    duplicatUserFound = true;
                    dupUsers.push(user.UserName);
                }
            }
        }
        messageObject.message += dupUsers.join(", ");
        if (duplicatUserFound) SystemActions.displayWarningMessage(messageObject);
    }

    private _addsecurityGroupUser = (users: IUser[]) => {
        this._validateUsers(users);
        if (users.length > 0) {
            EntitlementActions.addUsers(users);
        }
    }

    private _deleteSecurityGroupUser = (e: Event, user: IUser) => {
        EntitlementActions.deleteUser(user);
    }

    private _checkForUnsavedChanges = (event: any) => {
        if (EntitlementStore.getHasChanges()) {
            event.returnValue = InovxLoader.t('common:msgBox.browserSaveChanges');
        };
    }

    componentDidMount() {
        EntitlementStore.addChangeListener(this._loadState);
        SystemStore.addChangeListener(this._systemChange);
        window.addEventListener('beforeunload', this._checkForUnsavedChanges);
    }

    componentWillUnmount() {
        EntitlementStore.removeChangeListener(this._loadState);
        SystemStore.removeChangeListener(this._systemChange);
        window.removeEventListener('beforeunload', this._checkForUnsavedChanges);
    }

    render() {
        ListHelper.sort(this.state.applicationPermissions, "ApplicationDisplayName");

        var inputObj = {
            className: 'form-control',
            type: 'text'
        }
        var securityGroup = this.state.securityGroup;

        var getSystemSecurityGroupDisplayName = (name: string) => {
            switch (name) {
                case 'System Administrator': return InovxLoader.t('Entitlement:systemGroups.systemAdministrator.name');
                case 'Project Administrator': return InovxLoader.t('Entitlement:systemGroups.projectAdministrator.name');
                case 'User': return InovxLoader.t('Entitlement:systemGroups.user.name');
                default: return name;
            }
        };
        var getSystemSecurityGroupDisplayDescription = (name: string, description: string) => {
            switch (name) {
                case 'System Administrator': return InovxLoader.t('Entitlement:systemGroups.systemAdministrator.description');
                case 'Project Administrator': return InovxLoader.t('Entitlement:systemGroups.projectAdministrator.description');
                case 'User': return InovxLoader.t('Entitlement:systemGroups.user.description');
                default: return description;
            }
        };

        var nameInput = {
            ...inputObj,
            name: 'Name',
            id: 'entApp-groupName-input',
            value: securityGroup.IsSystemDefault ? getSystemSecurityGroupDisplayName(securityGroup.Name) : securityGroup.Name
        };

        var descriptionInput = {
            ...inputObj,
            name: 'Description',
            id: 'entApp-desc-input',
            value: securityGroup.IsSystemDefault ? getSystemSecurityGroupDisplayDescription(securityGroup.Name, securityGroup.Description) : securityGroup.Description
        };

        var header = this.state.isAdding ? InovxLoader.t('Entitlement:header.newSecurityGroup') : InovxLoader.t('Entitlement:header.editSecurityGroup');

        var columns = [{
                field: "UserName",
                headerText: InovxLoader.t('Entitlement:common.username'),
                width: "235px"
            }, {
                field: "FirstName",
                headerText: InovxLoader.t('Entitlement:common.firstname'),
                width: "150px"
            }, {
                field: "LastName",
                headerText: InovxLoader.t('Entitlement:common.lastname'),
                width: "150px"
            }, {
                field: "Enabled",
                headerText: InovxLoader.t('Entitlement:common.userStatus'),
                width: "165px",
                values: [
                    { value: true, text: InovxLoader.t('Entitlement:common.enabled') },
                    { value: false, text: InovxLoader.t('Entitlement:common.disabled') }
                ]
            }];

        var userDataSource = this.state.groupUsers;
        var userDefaultSort = [{
            field: "UserName",
            dir: "ascending"
        }];

        var userCommands = {
            command: [
                {
                    iconClassName: "glyphicon glyphicon-trash",
                    click: this._deleteSecurityGroupUser
                }],
            width: "85px",
            headerText: InovxLoader.t('Entitlement:common.commands')
        };

        var gridWidths = {
            permissionName: { width: "calc(40% - 40px)" },
            enabled: { width: "80px" },
            description: { width: "calc(60% - 40px)" }
        };

        return (
            <InovxControls.StaticHeaderForm title={header} saveOnClick={this._saveEntitlement} saveBtnId="entApp-save-btn" cancelOnClick={this._cancel} cancelBtnId="entApp-cancel-btn"
                isActionInProgress={this.state.isActionInProgress} inProgressMessage={this.state.actionInProgressMsg}>

                <InovxControls.FormField title={`${InovxLoader.t("Entitlement:form.name")}${securityGroup.IsSystemDefault ? '' : '*'}`} inputName='Name'>
                    <InovxControls.ValidationInput {...nameInput} className="form-control" onChange={this._onChange} readOnly={securityGroup.IsSystemDefault} validation={this.state.validation['Name']}/>
                </InovxControls.FormField>

                <InovxControls.FormField title={InovxLoader.t("Entitlement:form.description") } inputName='Description'>
                    <input {...descriptionInput} onChange={this._onChange} readOnly = {securityGroup.IsSystemDefault} />
                </InovxControls.FormField>

                <InovxControls.TabControl tabs={[InovxLoader.t("Entitlement:form.permissions"), InovxLoader.t("Entitlement:form.users")]}>

                    <InovxControls.Content >
                        <div className="entitlement-permissions">
                            {this.state.applicationPermissions.map((applicationPermission) => {
                                ListHelper.sort(applicationPermission.Permissions, "DisplayName");
                                return (
                                    <InovxControls.Expander title={applicationPermission.ApplicationDisplayName} key={applicationPermission.ApplicationDisplayName} >
                                        <div className="tg-table">
                                            <div className="tg-grid">
                                                <div className="tg-header-container">
                                                    <div className="tg-header tg-row">
                                                        <div className="tg-cell" style={gridWidths.permissionName}>
                                                            <div className="tg-hdr-ctnt">
                                                                <div className="tg-title">{InovxLoader.t('Entitlement:permission.name') }</div>
                                                            </div>
                                                        </div>
                                                        <div className="tg-cell" style={gridWidths.enabled}>
                                                            <div className="tg-hdr-ctnt">
                                                                <div className="tg-title">{InovxLoader.t('Entitlement:permission.enabled') }</div>
                                                            </div>
                                                        </div>
                                                        <div className="tg-cell" style={gridWidths.description}>
                                                            <div className="tg-hdr-ctnt">
                                                                <div className="tg-title">{InovxLoader.t('Entitlement:permission.description') }</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="tg-content-container" style={{ overflow: 'initial' }}>
                                                <div className='tg-content'>
                                                    {applicationPermission.Permissions.map((permission) => {
                                                        return (
                                                            <div className='tg-row' data-uid={permission.ID} key={permission.ID}>
                                                                <div style={gridWidths.permissionName} className='tg-cell'>{permission.DisplayName}</div>
                                                                <div style={gridWidths.enabled} className='tg-cell'> <input type="checkbox"  onChange={(event) => this._updatePermissions(permission.ID, event)}
                                                                    disabled = {securityGroup.IsSystemDefault}
                                                                    checked={ permission.Assigned}  className="checkbox"/></div>
                                                                <div style={gridWidths.description} className='tg-cell'>{permission.Description}</div>
                                                            </div>
                                                        );
                                                    }) }
                                                </div>
                                            </div>
                                        </div>
                                    </InovxControls.Expander>
                                );
                                }
                            ) }
                        </div>
                     </InovxControls.Content>
                    <InovxControls.Content class='entitlement-users-tab fc-margin'>

                        <InovxControls.FormField title={InovxLoader.t("Entitlement:form.assignUsers") } inputName='AssignUsers'>
                            <InovxControls.MultiSelect minLength={1} displayProp={"UserName"} url={`${UrlUtilities.getApiUrl()}/EntitlementApi/api/User/SearchUsers`} onClick={this._addsecurityGroupUser}
                                parameters={{ maxNumberOfResults: 5 }} numParameter='maxNumberOfResults' searchProperty={'searchString'} btnLabel={InovxLoader.t("Entitlement:form.addUserName") } keyProp="UserID"/>
                        </InovxControls.FormField>

                        <Inovx.Shared.Controls.Grid dataSource={userDataSource} commands={userCommands} columns={columns} defaultSort={userDefaultSort} sort={true}/>
                   </InovxControls.Content>
                </InovxControls.TabControl>
           </InovxControls.StaticHeaderForm>
        );
    }
}

export default EntitlementForm;
